import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FaChevronDown } from "react-icons/fa";
import { FlagIcon } from "react-flag-kit";
import { useTranslation } from "react-i18next";
import { BaseUrl } from "../../config";
import * as Avatar from "@radix-ui/react-avatar";
import {
  DashboardBrowsingIcon,
  Logout01Icon,
  Settings01Icon
} from "hugeicons-react";
import $ from "jquery";
import { useAuth } from "../../context/authContext";
import { LayoutDashboard } from "lucide-react";
import { PathLink } from "../../utils/PathLink";

export const getFlag = (lang) => {
  switch (lang) {
    case "fr":
      return <FlagIcon code="FR" size={17} />;
    case "de":
      return <FlagIcon code="DE" size={17} />;
    case "es":
      return <FlagIcon code="ES" size={17} />;
    case "dk":
      return <FlagIcon code="DK" size={17} />;
    case "nl":
      return <FlagIcon code="NL" size={17} />;
    default:
      return <FlagIcon code="GB" size={17} />;
  }
};

export default function TopBar() {
  const { t, i18n } = useTranslation();
  const [showLanguageMenu, setShowLanguageMenu] = useState(false);
  const [language, setLanguage] = useState(
    localStorage.getItem("i18nextLngsa") || i18n.language
  );

  const toggleLanguageMenu = () => {
    setShowLanguageMenu(!showLanguageMenu);
  };

  const handleLanguageChange = async (lng) => {
    if (!i18n.hasResourceBundle(lng, "translation")) {
      try {
        await i18n.loadLanguages(lng);
      } catch (error) {
        console.error("Erreur lors du chargement de la langue :", error);
      }
    }
    i18n.changeLanguage(lng);
    setLanguage(lng);
    setShowLanguageMenu(false);
    $(document).ready(function () {
      window.location.href = PathLink("");
    });
  };

  const [open, setOpen] = useState(false);

  const { userConnected, handleLogout } = useAuth();
  
  return (
    <div className="bg-tiers max-lg:hidden z-[150] flex w-full justify-end">
      <div className="flex gap-1 items-center py-0.5">
        <div className="flex">
          {userConnected ? (
            <div className="relative inline-block text-left">
              <button
                onClick={() => setOpen(!open)}
                className="text-[.8rem] cursor-pointer border-r border-gray-600 font-semibold flex gap-1.5 items-center px-4"
              >
                <Avatar.Root className="AvatarRoot inline-flex w-5 h-5 object-cover object-top rounded-full items-center justify-center overflow-hidden align-middle">
                  <Avatar.Image
                    className="AvatarImage object-cover w-full h-full"
                    src={userConnected?.thumbnail ? BaseUrl + "/" + userConnected?.thumbnail : ""}
                    alt={userConnected?.username || "User"}
                  />
                  <Avatar.Fallback className="AvatarFallback flex h-full w-full items-center justify-center bg-primary/10 text-sm font-semibold text-gray-800" delayMs={600}>
                    {userConnected?.username?.charAt(0)?.toUpperCase() || "U"}
                  </Avatar.Fallback>
                </Avatar.Root>
                {userConnected?.username || "Utilisateur"}
              </button>
              {open && (
                <div className="absolute z-[1000] right-0 text-[.9rem] mt-2 w-52 bg-white rounded-lg shadow-lg border border-gray-200 overflow-hidden">
                  <ul className="py-2 text-gray-800 font-medium">
                    <li>
                      <Link
                        to="/admin/dashboard"
                        className="px-5 py-2 hover:bg-gray-100 cursor-pointer flex items-center gap-3 transition-all"
                      >
                        <LayoutDashboard className="w-4 h-4 text-gray-600" />{" "}
                        Dashboard
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        className="px-5 py-2 hover:bg-gray-100 cursor-pointer flex items-center gap-3 transition-all"
                      >
                        <Settings01Icon strokeWidth={2} className="w-4 h-4 text-gray-600" />{" "}
                        Paramètres
                      </Link>
                    </li>
                    <li
                      onClick={handleLogout}
                      className="px-5 py-2.5 hover:bg-gray-100 cursor-pointer flex items-center gap-3 transition-all text-red-600 border-t border-gray-200"
                    >
                      <Logout01Icon className="w-4 h-4" /> Déconnexion
                    </li>
                  </ul>
                </div>
              )}
            </div>
          ) : (
            <Link
              to="/login"
              className="cursor-pointer text-[.7rem] px-4 border-x-2 border-gray-300"
            >
              {t("login")}
            </Link>
          )}
        </div> 
        <div className="relative">
          <button
            onClick={toggleLanguageMenu}
            className="text-[.7rem] px-4 py-2.5 flex items-center gap-1 cursor-pointer"
            title={t("changeLanguage")}
          >
            {getFlag(language)} <FaChevronDown />
          </button>
          {showLanguageMenu && (
            <div className="absolute right-0 mt-2 z-[1000] bg-white border border-gray-300 rounded shadow-lg w-40">
              <div
                onClick={() => handleLanguageChange("fr")}
                className="px-4 py-2 text-[.7rem] cursor-pointer hover:bg-gray-100 flex items-center gap-2"
              >
                <FlagIcon code="FR" size={16} /> Français
              </div>
              <div
                onClick={() => handleLanguageChange("en")}
                className="px-4 py-2 text-[.7rem] cursor-pointer hover:bg-gray-100 flex items-center gap-2"
              >
                <FlagIcon code="GB" size={16} /> English
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}